var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.275 7.83755L14.025 2.58755C13.875 2.43755 13.725 2.36255 13.5 2.36255H6C5.175 2.36255 4.5 3.03755 4.5 3.86255V21.8625C4.5 22.6875 5.175 23.3625 6 23.3625H18C18.825 23.3625 19.5 22.6875 19.5 21.8625V8.36255C19.5 8.13755 19.425 7.98755 19.275 7.83755ZM13.5 4.16255L17.7 8.36255H13.5V4.16255ZM18 21.8625H6V3.86255H12V8.36255C12 9.18755 12.675 9.86255 13.5 9.86255H18V21.8625Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.3625H16.5V18.8625H7.5V17.3625ZM7.5 12.8625H16.5V14.3625H7.5V12.8625Z",
    fill: "#1976D2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "file.964807cae366b2437ff4457632c7820d.svg";